import { Component, Input } from '@angular/core';

@Component({
    selector: 'page-heading',
    templateUrl: './heading.component.html',
    styleUrls: ['./heading.component.css'],
    standalone: false
})
export class HeadingComponent {
  @Input() heading: string = '';
  @Input() subHeading: string = '';
  @Input() imageUrl: string = '';
}
